import { SmileOutlined } from '@ant-design/icons';
import { Card, Col, Progress, Row, Typography } from 'antd';
import React, { PureComponent } from 'react';

import { Line, LineChart, ResponsiveContainer, XAxis, YAxis } from 'recharts';
import {
  getCurrentCreditScore,
  getMonthWiseScores,
} from '../../../Utils/creditBureau';

const { Text } = Typography;
type Props = {
  onBack: () => void;
};

const data = getMonthWiseScores();

const config = {
  data,
  xField: 'month',
  yField: 'score',
  smooth: true,
  height: 150,

  line: {
    color: '#ffffff', // White line color
  },
};
class CustomizedLabel extends PureComponent {
  render() {
    const { x, y, stroke, value }: any = this.props;

    return (
      <text
        x={x}
        y={y}
        dy={-10}
        fill={stroke}
        fontSize={10}
        textAnchor='middle'
      >
        {value}
      </text>
    );
  }
}

const CreditScoreView: React.FC = () => {
  const currentCreditScore = getCurrentCreditScore();
  const minValue = 300;
  const maxValue = 900;
  const percent =
    ((currentCreditScore - minValue) / (maxValue - minValue)) * 100;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
      <Card style={{ width: '100%', color: '#fff', border: 'none' }}>
        <div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div style={{ width: '40%', textAlign: 'center' }}>
              <div
                style={{
                  display: 'inline-block',
                  alignItems: 'center',
                  borderRadius: '50%',
                }}
              >
                <Progress
                  type='dashboard'
                  percent={percent}
                  //   format={percent => `${percent * 10}`}
                  strokeColor='green'
                  style={{
                    margin: '0 auto',
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                  }}
                  format={() => currentCreditScore}
                />
                <div style={{ fontSize: '14px', color: '#999' }}>Score</div>
              </div>
            </div>

            <Card
              style={{
                width: '55%',
                textAlign: 'center',
              }}
            >
              <Row justify='center' align='middle'>
                <Col>
                  <Text strong>Excellent</Text> <SmileOutlined />
                </Col>
              </Row>
              <Row justify='center' align='middle'>
                <Col>
                  <Text type='secondary'>As of 19 June, 2024</Text>
                </Col>
              </Row>

              <Row justify='center' align='middle'>
                <Col>Refresh in 14 Days</Col>
              </Row>
            </Card>
          </div>
        </div>
      </Card>
      <Typography.Text style={{ fontSize: 24, fontWeight: 600 }}>
        Your score history
      </Typography.Text>
      <Card>
        <div>
          <ResponsiveContainer width={'100%'} height={250}>
            <LineChart
              data={data}
              margin={{
                right: 15,
                left: -15,
              }}
            >
              <XAxis dataKey='month' padding={{ left: 10 }} />
              <YAxis
                axisLine={false}
                tickLine={false}
                domain={['dataMin - 5', 'dataMax + 5']}
              />
              <Line
                type='monotone'
                dataKey='score'
                stroke='#8884d8'
                label={<CustomizedLabel />}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </Card>
    </div>
  );
};

export default CreditScoreView;
